'use client'

import React from 'react'
import type { EnvironmentConfig } from '@/utilities/getEnvironment'

interface EnvironmentBadgeProps {
  className?: string
  envConfig?: EnvironmentConfig
}

export const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({
  className = '',
  envConfig,
}) => {
  // If no config passed, don't show badge
  if (!envConfig || !envConfig.showBadge) {
    return null
  }

  return (
    <div
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${className}`}
      style={{
        backgroundColor: envConfig.bgColor,
        color: envConfig.color,
        border: `2px solid ${envConfig.color}`,
      }}
    >
      {envConfig.label}
    </div>
  )
}
